/**
 * LeaveDutyService
 * Service for LeaveDuty entity operations
 * Route: api/leaveduties
 */
import { CrudService } from '../base/CrudService';
/**
 * LeaveDutyService
 * Handles leave duty CRUD operations
 */
export class LeaveDutyService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LeaveDutyService.DEFAULT_SERVICE_PATH,
            basePath: LeaveDutyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LeaveDutyService.DEFAULT_SERVICE_PATH = 'hr';
LeaveDutyService.BASE_PATH = 'api/leaveduties';
//# sourceMappingURL=LeaveDutyService.js.map